import { LuTarget } from "react-icons/lu";
import { TbAlertTriangle } from "react-icons/tb";
import {
  HiOutlineCog,
  HiOutlineEye,
  HiOutlineChartBar,
  HiOutlineLightningBolt,
  HiOutlineRefresh,
  HiOutlineTrendingUp,
  HiOutlineTrendingDown,
  HiChevronDown,
  HiChevronRight,
} from "react-icons/hi";

export const TargetIcon = () => <LuTarget size={20} />;

// Bullseye used in the Pilots card header (matches the 18px header icons).
export const PilotsIcon = () => <LuTarget size={18} />;

export const GearIcon = () => <HiOutlineCog size={14} />;

export const EyeIcon = () => <HiOutlineEye size={14} />;

export const BarChartIcon = () => <HiOutlineChartBar size={18} />;

export const ZapIcon = () => <HiOutlineLightningBolt size={16} />;

export const AlertIcon = () => <TbAlertTriangle size={16} />;

export const RenewIcon = () => <HiOutlineRefresh size={16} />;

export const TrendUpIcon = () => <HiOutlineTrendingUp size={16} />;

// Small trend arrows for metric delta chips (e.g. "+6 pts").
export const DeltaUpIcon = () => <HiOutlineTrendingUp size={12} />;

export const DeltaDownIcon = () => <HiOutlineTrendingDown size={12} />;

export const ChevronDownIcon = ({ expanded }) => (
  <HiChevronDown
    size={16}
    color="#94a3b8"
    className={`transition-transform duration-200 ${expanded ? "rotate-180" : ""}`}
  />
);

export const ChevronRightIcon = () => <HiChevronRight size={14} />;
